import { Injectable } from '@angular/core';
import { InternalMsgService } from './internal.msg.service';
import { AccountItem } from '../models/accountitem';
import { EmployeeService } from './employee/employee.service';
import { ReturnObject } from '../models/returnObject';
import { StatusMessagesService } from './statusmessage.service';

@Injectable( {
    providedIn: 'root'
} )
export class AccountService {
    private accessDenied: boolean = true;
    private curAccount: AccountItem = new AccountItem();
    private nonAccessRelatedFail: boolean = false;
    private fetchingAccount: boolean = false;
    
    constructor ( private msgService: InternalMsgService,
        private accountService: EmployeeService,
        private statusMessagesService: StatusMessagesService)   {}
        
        isFetchingAccount(): boolean {
            return this.fetchingAccount;
        }
        getAccountInfo(): void {
        if (this.fetchingAccount) return;
        this.fetchingAccount = true;
        this.accountService.getAccountInfo()
            .subscribe({
                next: (result: ReturnObject<AccountItem>) => {
                    if (result.isFailure) { // || !result.value.active) {
                        this.emptyAccount();
                        this.msgService.onLoggedInAccountSet(this.curAccount);
                        this.accessDenied = result.failureMessage.toLocaleLowerCase() == 'not authorized'
                        this.nonAccessRelatedFail = result.failureMessage.toLocaleLowerCase() != 'not authorized'
                        return;
                    }
                    this.curAccount.email = result.value.email;
                    this.curAccount.empId = result.value.empId;
                    this.curAccount.accountKey = result.value.accountKey;
                    this.curAccount.azureAccountName = result.value.azureAccountName;
                    this.curAccount.email = result.value.email;
                    this.curAccount.empName = result.value.empName;
                    this.curAccount.empNo = result.value.empNo;
                    this.curAccount.unit = result.value.unit;
                    this.curAccount.reporting = result.value.reporting;
                    this.curAccount.sysAdmin = result.value.sysAdmin;
                    this.curAccount.isSystemAilable = result.value.isSystemAilable;
                    this.curAccount.changeAdminAuthority =  result.value.changeAdminAuthority;
                    this.fetchingAccount = false;
                    this.msgService.onreadyForActionSet(true);
                    this.setAccount(this.curAccount);
                },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    //
                }
        });
    }

    isNonAccessRelatedFail(): boolean {
        return this.nonAccessRelatedFail;
    }

    emptyAccount(): void {
        this.curAccount = new AccountItem();
        localStorage.setItem('account', JSON.stringify(this.curAccount));
    }

    isAccessDenied(): boolean {
        return this.accessDenied;
    }
    fetchAccount(): void {
        if (!this.isValidAccount()) {
            this.getAccountInfo();
        } else {
            this.msgService.onLoggedInAccountSet(this.curAccount);
        }
    }

    isValidAccount(): boolean {
        return this.curAccount !== undefined
            && this.curAccount !== null
            && this.curAccount.azureAccountName.trim() !== ''
            && this.curAccount.email.trim() !== ''
            && this.curAccount.accountKey.trim() !== ''
            && this.curAccount.empName.trim() !== ''
            && this.curAccount.empNo.trim() !== ''
            && this.curAccount.empId.trim() !== ''
            && this.curAccount.email.trim() !== '';
    }

    setAccount(account: AccountItem): void {
        this.curAccount = account;
        localStorage.setItem('account', JSON.stringify(this.curAccount));
        this.msgService.onLoggedInAccountSet( this.curAccount )
    }

    getAccount(): AccountItem {
        const account: any = localStorage.getItem('account');
        if (account) {
            this.curAccount = JSON.parse(account);
        }
        return this.curAccount
            ? this.curAccount
            : new AccountItem();
    }

    logout() {
        this.curAccount = new AccountItem();
        localStorage.removeItem( 'account' );
        localStorage.removeItem( "menues" );
        this.msgService.onLoggedInAccountSet( this.curAccount );
    }
}
